import { v4 as uuidv4 } from 'uuid';

export class ColourModel {

    constructor (obj){
        this.id = uuidv4();
        this.labL = "";
        this.b = '';
        this.r = '';
        this.crPart = '';
        this.labA = '';
        this.scanDate = '';
        this.g = '';
        this.labB = '';
        this.operator = '';
        this.crSort = '';
        this.hex = '';

        if(obj){
            Object.assign(this, obj);
        }
        
    }

}
